import React, { useEffect, useRef } from "react";
import {
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar,
  IonButton,
  IonButtons,
  IonItem,
  IonInput,
  IonModal,
  IonText,
  IonCard,
} from "@ionic/react";
import { useIntl } from "react-intl";
import { useForm, Controller } from "react-hook-form";

const TwoFAModal = (props) => {
  const {
    handleCancel,
    visible,
    phoneNumber,
    onCodeChange,
    onSubmitCode,
    onResend,
    twoFAError,
    twoFACode,
    loading,
    resendLoading,
  } = props;
  const { handleSubmit, control, reset } = useForm();
  const inputRef = useRef();
  const onFinish = async () => {
    onSubmitCode();
  };

  const intl = useIntl();
  useEffect(() => {
    if (visible) {
      setTimeout(() => {
        if (inputRef.current) {
          return inputRef.current.setFocus();
        }
      }, 900);
    }
  }, [visible]);

  useEffect(() => {
    if (!visible) {
      reset({ code: null });
    }
  }, [visible]);
  return (
    <IonModal isOpen={visible}>
      <IonHeader>
        <IonToolbar color="primary">
          <IonTitle>
            {intl.formatMessage({
              id: "app.mobile.forms.user.2faTitle",
            })}
          </IonTitle>
          <IonButtons slot="end">
            <IonButton onclick={handleCancel}>סגור</IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonCard>
          <form onSubmit={handleSubmit(onFinish)}>
            <div className="ion-padding">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  width: "100%",
                  padding: "32px 0 80px 0",
                }}
              >
                <IonText color="muted">
                  <p>
                    {`${intl.formatMessage({
                      id: "app.mobile.2faCodeInstructions",
                    })}${
                      phoneNumber && phoneNumber.substr(phoneNumber.length - 4)
                    }********`}
                  </p>
                </IonText>

                <IonItem>
                  <Controller
                    control={control}
                    render={({ field }) => {
                      const { onChange, onBlur, value, ref } = field;

                      return (
                        <IonInput
                          {...field}
                          valueName={value}
                          onIonChange={(e) => {
                            onCodeChange(e.detail.value);
                            return onChange(e.detail.value);
                          }}
                          onTextBlur={(val) => onBlur(val)}
                          placeholder={intl.formatMessage({
                            id: "app.mobile.forms.user.codePlaceHolder",
                          })}
                          inputRef={ref}
                          ref={inputRef}
                        />
                      );
                    }}
                    name="code"
                  />
                </IonItem>
                <IonText
                  color="muted"
                  style={{
                    padding: "24px 0",
                    position: "absolute",
                    top: "140px",
                  }}
                >
                  {twoFAError ? (
                    <p
                      style={{
                        margin: "-20px 0 20px ",
                        width: "300px",
                        color: "#a61d24",
                      }}
                    >
                      {twoFAError
                        ? intl.formatMessage({
                            id: `app.notifications.${twoFAError}`,
                            defaultMessage: twoFAError,
                          })
                        : ""}
                    </p>
                  ) : null}
                </IonText>
              </div>

              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  <IonButton
                    color="primary"
                    type="submit"
                    disabled={!twoFACode || twoFACode.length < 6}
                    loading={loading}
                  >
                    {intl.formatMessage({
                      id: "app.mobile.actions.approve",
                    })}
                  </IonButton>

                  <IonButton fill="outline" onClick={handleCancel}>
                    {intl.formatMessage({
                      id: "app.mobile.actions.cancel",
                    })}
                  </IonButton>
                </div>

                <IonButton
                  fill="clear"
                  loading={resendLoading}
                  onClick={onResend}
                >
                  {intl.formatMessage({
                    id: "app.mobile.actions.resend",
                  })}
                </IonButton>
              </div>
            </div>
          </form>
        </IonCard>
      </IonContent>
    </IonModal>
  );
};

export default TwoFAModal;
